import { Badge } from '@forge/common'

interface ListingBadgeProps {
  status?: string | null
  mappedStatus?: string | null
}

export function ListingBadge({ status, mappedStatus }: ListingBadgeProps) {
  return (
    <Badge
      variant={
        mappedStatus === 'active'
          ? 'success'
          : mappedStatus === 'pending'
          ? 'warning'
          : mappedStatus === 'closed' || mappedStatus === 'deleted'
          ? 'danger'
          : mappedStatus === 'backup'
          ? 'info'
          : 'default'
      }>
      {status || 'N/A'}
    </Badge>
  )
}
